import axios from "axios";
import authHeader from "./auth-header";
import { API_URL_COMMON } from "./http.common";

const API_URL = `${API_URL_COMMON}`;

class SubscriptionService {
  getAllSubscriptions(params) {
    return axios({
      method: "get",
      url: `${API_URL}/subscriptions/all`,
      headers: authHeader(),
      params,
    });
  }

  getBillingStatus(accountUrn) {
    return axios({
      method: "get",
      url: `${API_URL}/subscriptions/${accountUrn}/billing-status`,
      headers: authHeader(),
    });
  }

  getInvoices(subscriptionId) {
    return axios({
      method: "get",
      url: `${API_URL}/subscriptions/invoices/${subscriptionId}`,
      headers: authHeader(),
    });
  }

  activateSubscription(subscriptionId) {
    return axios({
      method: "post",
      url: `${API_URL}/subscriptions/${subscriptionId}`,
      headers: authHeader(),
    });
  }

  cancelSubscription(subscriptionId) {
    return axios({
      method: "delete",
      url: `${API_URL}/subscriptions/${subscriptionId}/cancel`,
      headers: authHeader(),
    });
  }

  resumeSubscription(subscriptionId) {
    return axios({
      method: "post",
      url: `${API_URL}/subscriptions/${subscriptionId}/resume`,
      headers: authHeader(),
    });
  }

  retrySubscriptionPayment(subscriptionId) {
    return axios({
      method: "post",
      url: `${API_URL}/subscriptions/${subscriptionId}/retry-payment`,
      headers: authHeader(),
    });
  }

}

const subscriptionService = new SubscriptionService();

export default subscriptionService;
